export default __webpack_public_path__ + "assets/images/8caaf6c79bb34a981b020d7971872cb4.png";